module.exports = __webpack_public_path__ + "static/img/passo4.e82f292b.svg";